var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", [
    _c("p", { staticClass: "title" }, [_vm._v("Summary")]),
    _vm.value === ""
      ? _c("p", { staticClass: "subtitle has-text-success" }, [
          _vm._v(" Banking Amount: $0.00"),
        ])
      : _c("p", { staticClass: "subtitle has-text-success" }, [
          _vm._v(
            " Banking Amount: $" +
              _vm._s(_vm.$filters.formatNumber(_vm.value, _vm.$userInfo.locale))
          ),
        ]),
    _c(
      "div",
      { staticStyle: { "overflow-y": "auto", height: "400px" } },
      [
        _c(
          "bulma-table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "total-rows": _vm.entity.length,
              "show-pagination": false,
            },
          },
          [
            _vm._l(_vm.entity, function (item, index) {
              return _c(
                "tr",
                {
                  key: item.unclearedId,
                  class: { "is-selected": _vm.selectedRow === index },
                },
                [
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.remarks)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            item.debitAmount,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            _c("template", { slot: "empty" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-medium" } }, [
                    _c("i", {
                      staticClass:
                        "mdi mdi-36px mdi-dots-horizontal mdi-inactive-color mdi-inactive",
                    }),
                  ]),
                ]
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }